// extracted by mini-css-extract-plugin
export default {"popups-root":"c_1akU","popupsRoot":"c_1akU","popups-wrapper":"IwUlLl","popupsWrapper":"IwUlLl"};